require('leaflet/dist/leaflet');
require('leaflet.browser.print/dist/leaflet.browser.print.min');

export class VioletMap {
	defaultOptions() {
		return {
			type: "wrong_doing",
			readonly: true,
			mapCenter: getStationLatLon(),
			mapZoom: 7,
			routes: {
				dashboard: null,
				positions: null,
			},
			private: {
				mapController: null,
				markersLayer1: null,
				markersLayer2: null,
				markersPositions: null,
				positionsTimer: null,
			}
		};
	}

	loadConfiguration($mapWrapper) {
		if ($mapWrapper.data('type')) {
			this.$options.type = $mapWrapper.data('type'); 
		}
		if ($mapWrapper.data('readonly') !== undefined) {
			this.$options.readonly = ($mapWrapper.data('readonly') === true);
		}
		if ($mapWrapper.data('mapZoom')) {
			this.$options.mapZoom = parseInt($mapWrapper.data('mapZoom'));
		}
		if ($mapWrapper.data('routes')) {
			this.$options.routes = $mapWrapper.data('routes');
		}
	}
	
	constructor($mapWrapper) {
		this.$options = this.defaultOptions();
		this.loadConfiguration($mapWrapper);
		
		this.handleButtons();
		this.initMap();
		this.setupLayers();
	}

	//=====================================================================
	// Controls section
	//=====================================================================

	/**
	 * HANDLE BUTTONS
	 */
	handleButtons() {
		var app = this,
			$document = $(document),
			selectCoordinatesFirstClick = true,
			$bodyId = $('body').attr('id');

		this.$options.private.selectCoordinates = false;

		$document.on('change', '#dashboard-map-type', function (e) {
			e.preventDefault();
			app.switchDashboardLayers($(this).val())
		});

		$document.on('click', '#dashboard-map-reload', function (e) {
			e.preventDefault();
			app.loadHeatPoints();
		});

		$document.on('change', '#lat, #lon', function (e) {
			if ($bodyId === 'wrongDoings') {
				app.setupWrongDoingPoints();
			}
		});

		$document.on('change', '#latSpan, #lonSpan', function (e) {
			app.setupWrongDoingPoints();
		});

		$document.on('click', '#event-select-coordinates-btn', function (e) {

			const btn = $("#event-select-coordinates-btn");
			const map = $("#mapBody");

			if (app.$options.private.selectCoordinates) {
				btn.removeClass('active');
				map.removeClass('cursor-pointer');
				app.$options.private.selectCoordinates = false;
			}
			else {
				btn.addClass('active');
				map.addClass('cursor-pointer');
				app.$options.private.selectCoordinates = true;
			}

			if (app.$options.private.selectCoordinates && selectCoordinatesFirstClick)
			{
				app.selectPositionFromMap(btn, map);
				selectCoordinatesFirstClick = false
			}
		});

	}


	//=====================================================================
	// Map init section
	//=====================================================================

	/**
	 *
	 */
	initMap() {
		var mapCenter = this.$options.mapCenter,
			mapZoom = this.$options.mapZoom,
			mapController = L.map('mapBody').setView(mapCenter, mapZoom);

		//Create map
		L.tileLayer('https://{s}/{z}/{x}/{y}.png', {
			attribution: '&copy; Přispěvatelé <a href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap</a>.',
			maxZoom: 18,
			subdomains: ["a.tile.openstreetmap.org", "b.tile.openstreetmap.org", "c.tile.openstreetmap.org"],
			tileSize: 256,
		}).addTo(mapController);

		//Add markers layer
		this.$options.private.markersLayer1 = new L.LayerGroup().addTo(mapController);
		this.$options.private.markersLayer2 = new L.LayerGroup().addTo(mapController);
		this.$options.private.markersPositions = new L.LayerGroup().addTo(mapController);

		//Add print options
		L.control.browserPrint().addTo(mapController);

		//Set pointer to map controller
		this.$options.private.mapController = mapController;
	}

	//=====================================================================
	// Layers section
	//=====================================================================

	//Wrong doing location

	/**
	 *
	 */
	setupWrongDoingPoints() {
		var lat = $('#lat').val(),
			lon = $('#lon').val(),
			layerPtr = this.$options.private.markersLayer1,
			mapController = this.$options.private.mapController,
			mapCenter = this.$options.mapCenter;

		//Update marker
		layerPtr.clearLayers();
		//var icon = new L.Icon({ iconUrl: "assets/vulture.png", iconAnchor: [10, 15] });
		if (lat && lon) {
			var marker = L.marker([lat, lon]);
			marker.addTo(layerPtr);
		} else {
			lat = mapCenter[0];
			lon = mapCenter[1];
		}

		mapController.panTo(new L.LatLng(lat, lon));
	}
	
	//---------------------------------------------------------------------

	//Event

	selectPositionFromMap(btn, map) {

		const app = this;
		const mapController = app.$options.private.mapController;

		const 	latInput = $('#lat'),
				lonInput = $('#lon'),
				latSpan = $('#latSpan'),
				lonSpan = $('#lonSpan'),
				coordinatesFrom = $('#coordinatesFrom'),
				coordinatesSource = $('#coordinates_source');

		mapController.on('click', function(e) {
			
			let selectCoordinates = app.$options.private.selectCoordinates;
			
			if (selectCoordinates)
			{
				let lat = e.latlng.lat;
				let lon = e.latlng.lng;

				latInput.val(lat).trigger('change');
				lonInput.val(lon).trigger('change');
				latSpan.text(lat.toFixed(7)).trigger('change');
				lonSpan.text(lon.toFixed(7)).trigger('change');
				coordinatesFrom.text($Lang.events.coordinatesType.map);
				coordinatesSource.val(window.$Common.events.coordinatesSources.COORDINATES_MAP);

				btn.removeClass('active');
				map.removeClass('cursor-pointer');

				app.setupWrongDoingPoints();

				app.$options.private.selectCoordinates = false;
			}
		});
	}
	
	//---------------------------------------------------------------------

	//Dashboard map

	/**
	 *
	 */
	loadHeatPoints() {
		var app = this,
			dateFrom = $('#dashboard-map-from').val(),
			dateTo = $('#dashboard-map-to').val();

		const dateRegex = new RegExp(/^\s*\d{1,2}\.\d{1,2}\.\d{4}\s*$/);

		if (dateRegex.test(dateFrom) && dateRegex.test(dateTo)) {
			$.ajax({
				url: app.$options.routes.dashboard,
				dataType: 'json',
				data: {
					f: dateFrom,
					t: dateTo,
				},
				method: 'post',
				success: function (response) {
					app.fillHeatPoints(response, app)
				},
			});
		} else {
			bootbox.alert({
				message: "Neplatný formát data",
			});
		}
	}

	fillHeatPoints(response, app) {
		if (response && Array.isArray(response)) {

			var markers = [
					app.$options.private.markersLayer1,
					app.$options.private.markersLayer2,
				],
				i = 0;

			app.$options.private.markersLayer1.clearLayers();
			app.$options.private.markersLayer2.clearLayers();

			$.each(response, function (index, point) {
				var iconName = (point.type !== 1) ? "heat_other.png" : "heat_traffic.png",
					icon = new L.Icon({iconUrl: "images/" + iconName, iconAnchor: [40, 40]});

				for (i = 0; i < (Math.min(point.cnt, 6)); i++) {
					var marker = L.marker([point.lat, point.lon], {icon: icon});
					marker.addTo(markers[point.type - 1]);
				}
			});

		}
	}

	switchDashboardLayers(type) {
		var layer1 = this.$options.private.markersLayer1,
			layer2 = this.$options.private.markersLayer2,
			mapCtrl = this.$options.private.mapController;

		switch (type) {
			case '1':
				mapCtrl.addLayer(layer1);
				mapCtrl.removeLayer(layer2);
				break;

			case '2':
				mapCtrl.addLayer(layer2);
				mapCtrl.removeLayer(layer1);
				break;

			default:
				mapCtrl.addLayer(layer1);
				mapCtrl.addLayer(layer2);
				break;
		}
	}
	
	//---------------------------------------------------------------------

	loadSheriffPositions() {
		var app = this;

		//TODO zobrazovat pouze tem co na to maji pravo, udelat zaskrtavatko esli vubec zobrazit

		$.ajax({
			url: app.$options.routes.positions,
			dataType: 'json',
			data: null,
			method: 'get',
			success: function (response) {
				app.displaySheriffPositions(response, app)
			},
		});

		app.$options.private.positionsTimer = window.setTimeout(
			function () {
				app.loadSheriffPositions();
			},
			10000);	//TODO udelat nastavitelny timeout
	}

	displaySheriffPositions(response, app) {
		var layer = this.$options.private.markersPositions;

		if (response && Array.isArray(response)) {
			layer.clearLayers();
			$.each(response, function (index, point) {
				//TODO pridat title - ID a jmeno sherifa
				var marker = L.marker([point.lat, point.long]);
				marker.addTo(layer);
			});
		}
	}
	
	hideSheriffPositions() {
		var layer = this.$options.private.markersPositions,
			layer = this.$options.private.positionsTimer;
		layer.clearLayers();
		window.clearTimeout(app.$options.private.positionsTimer);
	}

	//---------------------------------------------------------------------

	/**
	 *
	 */
	setupLayers() {
		switch (this.$options.type) {
			case "wrong_doing":
				this.setupWrongDoingPoints();
				break;

			case "dashboard":
				this.loadHeatPoints();
				this.loadSheriffPositions();
				break;

			default:
				break;
		}
	}
}
